import { configEnv } from '@/shared/config-env';
import axios, {
  AxiosInstance,
  Method,
} from 'axios';
import { partial } from 'lodash-es';
import { axiosBitrix } from '@/shared/plugins/axiosBitrix';

export const request = async (axiosInstance: AxiosInstance, url: string, method: Method, params?: any, body?: any) => {
  const { data } = await axiosInstance.request({
    url,
    method,
    params,
    data: body,
  });

  return data;
};

/**
 * Запрос на сервис Dadata
 */
const dadateAxiosInstance = axios.create({
  baseURL: configEnv.DADATA_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': 'Token ' + configEnv.DADATA_TOKEN,
  },
});
export const dadataRequest = partial(request, dadateAxiosInstance);

/**
 * Запрос на БУС (BitrixCMS)
 */
export const bitrixRequest = partial(request, axiosBitrix);

export const serviceRequest = partial(request, axios);
